import { FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material'
import React, { useEffect } from 'react'
import { Controller, useWatch } from 'react-hook-form'
import { FormInputProps } from '../../../types/formInputProps'

interface CheBoxProps extends Omit<FormInputProps, 'label'> {
  forceValidate?: boolean
  forceupdate?: boolean
}

const FormInputLangLoves: React.FC<CheBoxProps> = ({
  name,
  control,
  forceValidate,
}) => {
  const options = [
    'Одобрение',
    // 'Прикосновения',
    'Время',
    'Помощь',
    'Подарки',
  ]

  const watchedValue = useWatch({
    control,
    name,
    defaultValue: (control as any)?._defaultValues?.[name],
  })

  useEffect(() => {
    if (watchedValue && typeof window !== 'undefined') {
      localStorage.setItem('prelanglove1', watchedValue)
    }
  }, [watchedValue])

  // Функция для валидации
  const validate = (value: string | undefined) => {
    if (forceValidate && !value) {
      return 'Выберите хотя бы один вариант' // Сообщение об ошибке
    }
    return undefined
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={{ validate }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <div style={{ border: '2px solid', borderColor: '#8768c8', borderRadius: '10px' }}>
            <RadioGroup
              row
              aria-labelledby={`input-radio-${name}`}
              name={'position' + name}
              id={'input-radio-' + name}
              value={value || ''}
              onChange={(e) => {
                const val = e.target.value
                onChange(val)
                if (typeof window !== 'undefined') {
                  localStorage.setItem('prelanglove1', val)
                }
              }}
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              {options.map((option) => {
                const isChecked = (value?.trim() ?? '') === option.trim()

                return (
                  <FormControlLabel
                    key={option + name}
                    value={option}
                    sx={{
                      color: 'white',
                      borderRadius: '5px',
                      backgroundColor: '#8768c8',
                      margin: '5px',
                      width: 'calc(50% - 10px)',
                      boxSizing: 'border-box',
                      maxWidth: '50%',
                    }}
                    label={option}
                    labelPlacement="start"
                    disabled={option === 'Прикосновения'}
                    control={
                      <Radio
                        sx={{
                          '&, &.Mui-checked': {
                            color: '#ffffff',
                          },
                        }}
                        checked={isChecked}
                      />
                    }
                  />
                )
              })}
            </RadioGroup>
          </div>
          {error && (
            <FormHelperText error style={{ textAlign: 'center', marginTop: '5px' }}>
              {error.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  )
}

export default FormInputLangLoves
